import { render, staticRenderFns } from "./CardSms.vue?vue&type=template&id=6f96d336&scoped=true&"
import script from "./CardSms.vue?vue&type=script&lang=js&"
export * from "./CardSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f96d336",
  null
  
)

export default component.exports